import { useContext, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import { clearSession, setAuthenticated } from "@/stores/slice/authSlice";
import { AuthContext } from "@/pages/auth/AuthContext";

export const useAuth = () => {
  const authContext = useContext(AuthContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { has_authenticated, session_timer, last_activity } = useSelector(
    (state) => state.auth
  );

  // Enhanced login function with session management
  const loginWithSession = useCallback(
    (accessToken, role, username, ship_id, user_id, reset_new) => {
      // Use existing login from context
      authContext.login(
        accessToken,
        role,
        username,
        ship_id,
        user_id,
        reset_new
      );
      if (reset_new) {
        navigate("/setup");
        return;
      }
      // Initialize session timer for BRIDGE and ENGINE_ROOM users
      if (role === "BRIDGE" || role === "ENGINE_ROOM") {
        dispatch(setAuthenticated(true));
        message.success("Login successfully");
      }
    },
    [authContext, dispatch]
  );

  const logoutWithSession = useCallback(
    (isManualLogout = true) => {
      dispatch(clearSession());

      // Navigate based on logout type
      if (isManualLogout) {
        navigate("/login");
        message.info("Logged out successfully");
      } else {
        // Session expired - redirect to MPIN for session-managed users
        const currentRole = localStorage.getItem("role") || authContext.role;
        if (currentRole === "BRIDGE" || currentRole === "ENGINE_ROOM") {
          navigate("/mpin");
          message.warning(
            "Session expired. Please enter your MPIN to continue."
          );
        } else {
          navigate("/login");
          message.warning("Session expired. Please login again.");
        }
      }
    },
    [authContext, dispatch, navigate]
  );

 
  // Check if user needs session management
  const needsSessionManagement = useCallback(() => {
    const { role } = authContext;
    return role === "BRIDGE" || role === "ENGINE_ROOM";
  }, [authContext]);

  return {
    ...authContext,

    login: loginWithSession,
    sessionlogout: logoutWithSession, // Now accepts isManualLogout parameter
 
    // Session-related properties
     needsSessionManagement: needsSessionManagement(),
    hasAuthenticated: has_authenticated,
    sessionTimer: session_timer,
    lastActivity: last_activity,
  };
};
